import script from "./FollowUpFeedbackForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowUpFeedbackForm.vue?vue&type=script&setup=true&lang=js"

import "./FollowUpFeedbackForm.vue?vue&type=style&index=0&id=32b70fa9&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b70fa9"]])

export default __exports__